import {
  Stack as MuiStack,
  Drawer as MuiDrawer,
  useTheme,
} from '@mui/material';
import { ReactComponent as MenuIcon } from '@assets/icons/ic-menu.svg';
import TopNavLanguageButton from '@organisms/TopNavLanguageButton/TopNavLanguageButton';
import TopNavAvatarButton from '@organisms/TopNavAvatarButton/TopNavAvatarButton';
import Sidebar from '@organisms/Sidebar/Sidebar';
import { useEffect, useState } from 'react';
import { useResponsive } from '@hook/useResponsive';
import { TopNavDesktopHeight, TopNavMobileHeight } from './config-topnav';
import { useAuthContext } from '@contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { MiniSidebarWidth } from '@organisms/Sidebar/config-sidebar';

function TopNav() {
  const theme = useTheme();
  const { iam } = useAuthContext();
  const { isMobile } = useResponsive();
  const location = useLocation();

  const [isDrawer, setIsDrawer] = useState<boolean>(false);

  /** drawer Click Event */
  const toggleDrawer = () => {
    setIsDrawer(!isDrawer);
  };

  useEffect(() => {
    if (isMobile) {
      setIsDrawer(false);
    }
  }, [location.pathname]);

  return (
    <>
      <MuiStack
        direction={'row'}
        alignItems={'center'}
        justifyContent={isMobile ? 'space-between' : 'flex-end'}
        padding={theme.spacing(2)}
        sx={{
          position: 'sticky',
          top: 0,
          background: theme.palette.background.paper,
          height: isMobile ? TopNavMobileHeight : TopNavDesktopHeight,
          zIndex: 1,
        }}
      >
        {isMobile && (
          <MuiStack
            onClick={toggleDrawer}
            sx={{ width: 'max-content', cursor: 'pointer' }}
          >
            <MenuIcon />
          </MuiStack>
        )}
        <MuiStack direction={'row'} gap={1}>
          <TopNavLanguageButton />
          <TopNavAvatarButton
            email={iam?.email}
            imgUrl={iam?.profileImageUrl}
            displayName={iam?.nickName}
          />
        </MuiStack>
      </MuiStack>
      {isMobile && (
        <MuiDrawer
          anchor={'left'}
          open={isDrawer}
          onClose={toggleDrawer}
          sx={{ '& .MuiDrawer-paper': { width: MiniSidebarWidth } }}
        >
          <Sidebar />
        </MuiDrawer>
      )}
    </>
  );
}

export default TopNav;
